module.exports = __webpack_public_path__ + "static/media/background.1e56705e.jpg";